import { render, staticRenderFns } from "./pickContact.vue?vue&type=template&id=0064ee76&scoped=true&"
import script from "./pickContact.vue?vue&type=script&lang=js&"
export * from "./pickContact.vue?vue&type=script&lang=js&"
import style0 from "./pickContact.vue?vue&type=style&index=0&id=0064ee76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0064ee76",
  null
  
)

export default component.exports